import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { DealerForm } from '@C/Admin/AccountCreation';
import ErrorBoundary from '@C/Error';

class CreateDealerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Create dealer" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <DealerForm />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { CreateDealerPage };
